import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  min-width: 100vh;
  min-height: 100vh;
  flex-direction: column; 
  align-items: center;
  justify-content: center;

  background-color: #F3F5F4;
  border-radius: 10px;
`;

export const AlertText = styled.h3`
  color: #9E9E9E;
  font-size: 24px;
  font-weight: 100;
`;
